/**
 * VireoHR - Header Component
 * Ultra-Minimal: White background, thin border
 */

import { Link } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';

interface HeaderProps {
  title: string;
  showSettings?: boolean;
}

export default function Header({ title, showSettings = true }: HeaderProps) {
  const { user } = useAuth();

  return (
    <div className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between sticky top-0 z-40">
      <div>
        <h1 className="text-lg font-semibold text-[#0D9488]">{title}</h1>
        {user?.tenantName && (
          <p className="text-xs text-gray-500">{user.tenantName}</p>
        )}
      </div>
      {showSettings && (
        <Link 
          to="/settings" 
          className="text-gray-600 hover:text-[#0D9488] transition"
          aria-label="Settings"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        </Link>
      )}
    </div>
  );
}
